import api from '../../api/api';
import pubSub from '../utility/pub-sub';
import { urlParamsFormatter } from '../../app/utility/string';

import { Response, ListItem, AvailableFilter } from './top-search.interface';
import TextField from './text-field';
import template from './top-search.template';
import SpellSuggestion from './spell-suggestion';
import availableFiltersTemplate from './filter-buttons-categories.template';
import filterButtonCategoriesObserver from './filter-button-categories.observer';
import filterButtonsObserver from './filter-buttons.observer';

export default class TopSearch {
  response: Response;
  listItems: ListItem[];
  isLoading: boolean = false;
  currentPage: number = 1;
  filters: { [prop: string]: any } = {
    query: ''
  };
  debounceTime: ReturnType<typeof setTimeout> = null;
  endPoint: string;
  endPage: string;
  resultList: HTMLElement;
  searchPageUrl: string;
  pageType: string[] = [];
  orderValue: string = 'all';
  resultSection: HTMLElement;
  pageSearchLinks: HTMLCollection;
  spellSuggestion: SpellSuggestion;
  shouldRenderFilterButtons: boolean;

  constructor() {
    this.setEndPoints();
    this.setResultList();
    filterButtonCategoriesObserver(
      this.onFilterChanged.bind(this),
      () => this.shouldRenderFilterButtons,
      this.setButtonRender.bind(this)
    );

    filterButtonsObserver(this.onFilterChanged.bind(this));

    new TextField(
      (document.getElementById('js-top-search-form-field') as HTMLInputElement),
      {
        onFilterChanged: this.onFilterChanged.bind(this),
        resetAll: this.resetAll.bind(this),
        setFilterRender: this.setButtonRender.bind(this),
      }
    );
    this.resultSection = document.getElementById('js-search-results');
    this.pageSearchLinks = document.getElementsByClassName('js-page-search');

    // Reset result list and filters
    document.querySelectorAll('.js-reset-search').forEach((button: HTMLButtonElement) => {
      button.addEventListener('click', this.resetAll.bind(this));
    });
  }

  setEndPoints() {
    const searchOverlay = document.getElementById('search-overlay');
    if (searchOverlay) {
      const endPoint = searchOverlay.getAttribute('data-endpoint') || null;
      const endPage = searchOverlay.getAttribute('data-page-url') || null;

      if (endPoint || endPage) {
        this.endPoint = endPoint;
        this.endPage = endPage;
        this.searchPageUrl = this.endPage;
      }
    }
  }

  setResultList = () => {
    this.resultList = document.getElementById('js-result-list');
  }

  setPageType = (filterValues: string[]) => {
    if (!this.pageType) {
      this.pageType = [];
    }

    this.pageType = Array.from(
      new Set([...this.pageType, ...filterValues]),
    );
  }

  updatePageSearchLinks() {
    Array.from(this.pageSearchLinks).forEach(link => link.setAttribute('href', `${this.searchPageUrl}?query=${encodeURIComponent(this.filters.query)}`))
  }

  /**
   * Fetch results with endpoint and filters
   */
  fetchResults = async () => {
    const params = {
      page: this.currentPage,
      ...this.filters,
    };
    clearTimeout(this.debounceTime);
    this.debounceTime = setTimeout(async () => {
      try {
        this.isLoading = true;
        const url = urlParamsFormatter(this.endPoint, params);
        const response = await api.get(url);
        this.response = response.data;
        this.listItems = response.data.items;
        this.isLoading = false;
        this.resultSection.classList.remove('hidden');
        this.updatePageSearchLinks();
        SpellSuggestion.render(this.response?.spellSuggestions?.params, this.searchPageUrl);
        this.render(this.listItems);
        if (this.shouldRenderFilterButtons) {
          this.renderFilterButtons(response.data.availableFilters);
          pubSub.publish('availableFilters', {
            data: response.data.availableFilters
          })
        }
      } catch (error) {
        this.isLoading = false;
        // Error handler
      }
    }, 400);
  };

  onFilterChanged = (filterObject: {
    [key: string]: unknown;
  }) => {
    if (filterObject) {
      const currentState = this.filters;
      this.filters = {
        ...currentState,
        ...filterObject,
      };
      this.currentPage = null;
      this.fetchResults();
    }
  };

  render = (items: ListItem[]) => {
    const templateResults = template(items);
    this.resultList.innerHTML = templateResults;
  }

  renderFilterButtons = (availableFilters: AvailableFilter[]) => {
    const filters = availableFiltersTemplate([{ displayName: 'All'}, ...availableFilters]);
    const fiterWrapper = document.getElementById('js-filter-button-wrapp');
    fiterWrapper.innerHTML = filters;
  }

  setButtonRender = (value: boolean) => this.shouldRenderFilterButtons = value;

  hideResetButton() {
    const resetButton = document.getElementsByClassName('js-reset')[0];
    if (resetButton) {
      resetButton.classList.add('hidden');
    }
  }

  // Filters
  resetAll() {
    this.pageType = [];
    this.orderValue = 'all';
    this.filters.query = '';
    this.listItems = [];
    this.resultSection.classList.add('hidden');
    Array.from(document.getElementsByClassName('js-filter-button')).forEach((item) => item.classList.remove('active'));
    this.hideResetButton();
    $(document.getElementById('select-component-top-search')).val('all').trigger('change');
    (document.getElementById('js-top-search-form-field') as HTMLInputElement).value = '';
  }
}
